import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	DatePicker
} from 'element-ui';

import {
	cloneDeep
} from 'lodash';

import moment from 'moment';

import {
	mapFilters
} from '@/support/map';

export default {
	name: 'filter-inbox',
	components: {
		DatePicker
	},
	props: {
		context: {
			type: String
		}
	},
	data: () => ({
		filter: {}
	}),
	computed: {
		...mapGetters([
			'getLoggedUser',
			'inboxReceivedFilter',
			'inboxSentFilter',
			'settings'
		])
	},
	methods: {
		...mapActions([
			'setReceivedInboxFilter',
			'setSentInboxFilter',
			'getReceivedMessages',
			'getSentMessages'
		]),
		...mapFilters([
			'capitalize'
		]),
		filterMessage() {

			const payload = {
				filter: cloneDeep(this.filter),
				data: this.getLoggedUser
			};

			payload.filter.quantity = this.settings.Pagination.pageSize;
			payload.filter.page = 0;

			if (payload.filter.startDate) {
				payload.filter.startDate = moment(payload.filter.startDate).format('YYYY-MM-DD');

			}
			if (payload.filter.endDate) {
				payload.filter.endDate = moment(payload.filter.endDate).format('YYYY-MM-DD');
			}

			if (payload.filter.onlyNotReadedMessages !== '' && typeof payload.filter.onlyNotReadedMessages === 'number') {
				payload.filter.onlyNotReadedMessages = parseInt(payload.filter.onlyNotReadedMessages);
			}

			this[`set${ this.capitalize(this.context) }InboxFilter`](payload.filter);
			this[`get${ this.capitalize(this.context) }Messages`](payload);

		},
		clearFilter() {

			this.filter = {};

			this[`set${ this.capitalize(this.context) }InboxFilter`]({
				studentName: '',
				memberName: '',
				onlyNotReadedMessages: null,
				startDate: null,
				endDate: null
			});

			this.filterMessage();

		}
	},
	created() {

		this.filter = cloneDeep(this[`inbox${ this.capitalize(this.context) }Filter`]);

		if (this.filter.startDate) {
			this.filter.startDate = new Date(`${ this.filter.startDate } 00:00:00`);
		}

		if (this.filter.endDate) {
			this.filter.endDate = new Date(`${ this.filter.endDate } 00:00:00`);
		}

	}
};



// WEBPACK FOOTER //
// ./sources/domains/inbox/filter-inbox/index.js